/**
 * en-GB messages added by Phase 4 task C9 (docs/PHASE-4-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const c9EnGB = {
    'email.core.closure_requested.subject': '{tenant} will be closed on {date}',
    'email.core.closure_requested.body': 'The CloudSign account for {tenant} has been closed at your organisation\'s request. Sign-in is switched off now. All data will be deleted on {date}, {days} days from today. A full export of your data is being prepared and your administrator can download it before then.',
    'email.core.closure_requested.button': 'Open CloudSign',
    'email.core.closure_reminder.subject': 'Your CloudSign data for {tenant} will be deleted on {date}',
    'email.core.closure_reminder.body': 'This is a reminder that the CloudSign account for {tenant} will be closed and all its data deleted on {date}. Download your export before then if you still need it.',
    'email.core.closure_reminder.button': 'Open CloudSign',
    'email.core.closure_done.subject': 'The CloudSign account for {tenant} has been deleted',
    'email.core.closure_done.body': 'The CloudSign account for {tenant} and all of its data have now been deleted, as arranged. Nothing more is needed from you.',
    'email.core.closure_done.button': 'CloudSign',
    'error.closure_pending': 'This organisation is already being closed.',
    'error.closure_none': 'This organisation has no closure waiting.',
    'error.closure_due': 'The closure is due now and can no longer be cancelled.',
    'error.closure_slug_mismatch': 'The organisation address you typed does not match.',
    'error.tenant_archived': 'This organisation is closed.',
};
//# sourceMappingURL=c9.js.map